"use strict";

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormidableProvider = void 0;

var react_1 = require("@emotion/react");

var react_2 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var createStore_1 = __importDefault(require("./createStore"));

var defaultState = {
  extendData: undefined,
  sc: undefined,
  store: undefined,
  t: undefined
};
var FormidableContext = react_2.default.createContext(defaultState);

var FormidableProvider = function FormidableProvider(_ref) {
  var children = _ref.children,
      extendData = _ref.extendData,
      extraArguments = _ref.extraArguments,
      extraReducers = _ref.extraReducers,
      initializeStore = _ref.initializeStore,
      _ref$initialState = _ref.initialState,
      initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
      sc = _ref.sc,
      t = _ref.t,
      theme = _ref.theme;

  var _ref2 = (0, react_2.useState)((0, createStore_1.default)(initialState, extraReducers, extraArguments)),
      _ref3 = _slicedToArray(_ref2, 1),
      store = _ref3[0];

  if (initializeStore) {
    initializeStore(store);
  }

  return react_2.default.createElement(FormidableContext.Provider, {
    value: {
      extendData: extendData,
      sc: sc,
      store: store,
      t: t
    }
  }, react_2.default.createElement(react_redux_1.Provider, {
    store: store
  }, theme ? react_2.default.createElement(react_1.ThemeProvider, {
    theme: theme
  }, children) : children));
};

exports.FormidableProvider = FormidableProvider;
exports.default = FormidableContext;